import axios from "axios";
import { toastr } from "react-redux-toastr";
import { logout } from "./auth";
import { NEW_PARTNER_REQUESTS } from "./types";

// The Partners page: the requests of cloudprint.mn's partner pages (/api/partners, the
// backend's routes/api/partners.js). Kept on the page, not in the store: each call
// returns what the backend sent, or null when it failed and the error was shown. Only
// the count of new requests goes to the store, for the sidebar badge.

// Shows the backend's { errors: [{ msg }] } and logs out on an expired token
const handleError = (err, dispatch) => {
	// No response: the network or the server is down
	if (!err.response) {
		toastr.error("Сервертэй холбогдож чадсангүй");
		return;
	}
	if (err.response.status === 401 && err.response.data.msg === "Token is not valid") {
		window.localStorage.clear("x-auth-token");
		toastr.error("Session expired");
		dispatch(logout());
	}
	const errors = err.response.data.errors;
	if (errors) {
		errors.forEach((error) => toastr.error(error.msg));
	}
};

const config = {
	headers: {
		"Content-Type": "application/json",
	},
};

// A backend without these routes answers with the admin's index.html and a 200
const isList = (data) => Boolean(data) && Array.isArray(data.requests) && Boolean(data.counts);
const isRequest = (data) => Boolean(data) && typeof data.id === "string" && typeof data.status === "string";

const call = async (dispatch, request, isRight, done) => {
	try {
		const res = await request();
		if (!isRight(res.data)) {
			toastr.error("Серверийн хариу буруу байна");
			return null;
		}
		if (done) toastr.success(done);
		return res.data;
	} catch (err) {
		handleError(err, dispatch);
		return null;
	}
};

//  The newest requests of a status (new, contacted, agreed, declined), with the counts.
//  The page reloads after each save, so the badge follows it.
export const getPartnerRequests = (status) => async (dispatch) => {
	const data = await call(dispatch, () => axios.get("/api/partners", { params: { status } }), isList);
	if (data) dispatch({ type: NEW_PARTNER_REQUESTS, payload: data.counts.new || 0 });
	return data;
};

//  Count the new requests for the sidebar badge. Fails silently: the badge is extra.
export const getNewPartnerCount = () => async (dispatch) => {
	try {
		const res = await axios.get("/api/partners/count");
		if (typeof res.data.count !== "number") return;
		dispatch({ type: NEW_PARTNER_REQUESTS, payload: res.data.count });
	} catch (err) {}
};

//  Saves a request's status and note
export const savePartnerRequest = (id, status, note) => (dispatch) =>
	call(dispatch, () => axios.put(`/api/partners/${id}`, { status, note }, config), isRequest, "Хадгалагдлаа");
